// Набор элементов интерфейса. План: docs/UI-KIT-PLAN.md.
//
// ЖЕЛЕЗНОЕ: голых `<input>`, `<select>`, `<textarea>`, `<button>` на страницах больше
// не пишут — элемент берётся отсюда. Причина (разбор с владельцем 2026-08-10): контролов
// как компонентов в проекте не было вовсе, поэтому каждый новый экран верстался заново и
// расходился видом с соседними. Вид набора описан в kit.css нашими переменными,
// поведение — на Radix.
export { cx } from './cx';
export { KButton, KBareButton, KPill } from './button';
export type { KButtonTone, KButtonSize } from './button';
export { KInput, KTextarea } from './input';
export { KSelect, KPickSheet, wantsPickSheet } from './select';
export type { KOption } from './select';
export { KWheelDialog } from './wheel';
export type { KWheelColumn } from './wheel';
export { KCheckbox, KSwitch } from './toggle';
export { KFormGroup, KFormCaption, KField, KSegment, KChoice, KChoiceMany, KActionBar } from './form';
export { KDialog } from './dialog';
export { KCalendar } from './calendar';
export type { KCalendarDay } from './calendar';
export { useExitPresence } from './exit-presence';
export { KTooltip } from './tooltip';
export { KListRow, KListGroup, KListSection, KListNote, KListCheck, KListValueIcon, KListBlock, KListField, KListForm } from './list';
export type { KListRowTone } from './list';
export { KSearch } from './search';
export { KEmpty } from './empty';
export { KDots } from './dots';
export { KSkeleton, KSkeletonField } from './skeleton';
export { KDisclosure } from './disclosure';
export { GoalSeg } from './goal-seg';
export type { GoalSegOption } from './goal-seg';
export { KToast, TOAST_MS } from './toast';
export type { KToastTone } from './toast';
